import { createSelector } from '@ngrx/store';
import { BuyerState } from '../state';
import { getBuyerState } from '../feature-selector';
import { SearchSuggestionsState } from './search-suggestions.state';

export const getSearchSuggestionsState = createSelector(
  getBuyerState,
  (state: BuyerState) => state && state.searchSuggestions,
);
export const getSearchSuggestionsItems = createSelector(getSearchSuggestionsState, (state: SearchSuggestionsState) =>
  state && state.suggestions);

export const getSearchSuggestionsHistoryTerms = createSelector(
  getSearchSuggestionsState,
  (state: SearchSuggestionsState) => state && state.historyTerms,
);

export const getSearchSuggestionsProducts = createSelector(
  getSearchSuggestionsState,
  (state: SearchSuggestionsState) => {
    return state && state.products;
  }
);

export const getSearchSuggestionsError = createSelector(
  getSearchSuggestionsState,
  (state: SearchSuggestionsState) => state && state.error,
);

export const isSearchSuggestionsListVisible = createSelector(
  getSearchSuggestionsState,
  (state: SearchSuggestionsState) => state && state.isSuggestionsListVisible,
);
